import React from "react";
import Header from "../CommonAppLayout/Header";
import Footer from "../CommonAppLayout/Footer";

export default function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main style={{ minHeight: "80vh" }}>
        {children}
      </main>
      <Footer />
    </>
  );
}
